import { Button } from "@/components/ui";
import { DocumentsPanel } from "@/screens/KnowledgeScreen";
import { useCompleteStep } from "./useCompleteStep";

export function DocumentsStep() {
  const complete = useCompleteStep();
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-[24px] font-bold tracking-[-0.02em]">
          Anything not on the website?
        </h1>
        <p className="mt-1 text-[14px] text-muted">
          Price lists, FAQs, brochures, policies. PDF, Word, text, Markdown or
          CSV, up to 20 MB each. Optional — you can add more later.
        </p>
      </div>
      <DocumentsPanel />
      <div className="flex justify-end">
        <Button
          variant="primary"
          disabled={complete.isPending}
          onClick={() => complete.mutate("documents")}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
